import * as React from 'react';
export const stripeSvg = React.forwardRef(function stripeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#6772E5',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M14.56 12.33c0-.78.64-1.08 1.7-1.08 1.52 0 3.43.46 4.95 1.28v-4.7c-1.66-.65-3.3-.91-4.95-.91-4.05 0-6.75 2.11-6.75 5.65 0 5.5 7.59 4.63 7.59 7 0 .92-.8 1.22-1.92 1.22-1.65 0-3.77-.68-5.45-1.6v4.75c1.86.8 3.74 1.14 5.45 1.14 4.15 0 7-2.05 7-5.63-.01-5.94-7.62-4.89-7.62-7.12z',
      }),
    ),
  );
});
stripeSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var stripe = {
  category: 'brand',
  colorable: false,
  name: 'stripe',
  svg: stripeSvg,
};
